/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ counted: NonNullable<unknown>, total: NonNullable<unknown> }} Stocktake_ProgressInputs */

const vi_stocktake_progress = /** @type {(inputs: Stocktake_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.counted}/${i?.total} dòng đã kiểm`)
};

/**

* @param {Stocktake_ProgressInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_progress = /** @type {((inputs: Stocktake_ProgressInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_ProgressInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_progress(inputs)
});